import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { dateTimeFormat } from "utils/format";
import { Cut } from "components/Cut";

import "./sendingPriceListHistoryTable.scss";

const STATUS_LABELS = {
  1: "В очереди",
  2: "Отправлено",
};

export const SendingPriceListHistoryTable = ({ items }) => {
  const tableColumns = [
    {
      dataField: "splName",
      text: "Рассылка",
      formatter: (cell, row) => (
        <a href={`/sales/sendingPriceList/${row.splId}`} target="_blank" rel="noreferrer">
          <Cut>{cell}</Cut>
        </a>
      ),
      headerStyle: () => ({ width: "15%" }),
    },
    {
      dataField: "date",
      text: "Дата",
      formatter: (cell) => dateTimeFormat(cell),
      headerStyle: () => ({ width: "12%" }),
    },
    {
      dataField: "email",
      text: "Email",
      formatter: (cell) => {
        return <Cut>{Array.isArray(cell) ? cell.join(", ") : cell}</Cut>;
      },
      headerStyle: () => ({ width: "20%" }),
    },
    {
      dataField: "file",
      text: "Файл",
      formatter: (cell) => <Cut>{cell}</Cut>,
      headerStyle: () => ({ width: "15%" }),
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: () => ({ width: "8%" }),
    },
    {
      dataField: "status",
      text: "Статус",
      formatter: (cell) => STATUS_LABELS[cell] ?? cell,
      headerStyle: () => ({ width: "10%" }),
    },
    {
      dataField: "error",
      text: "Ошибка",
      formatter: (cell) => <Cut>{cell}</Cut>,
      headerStyle: () => ({ width: "20%" }),
    },
  ];

  return (
    <BootstrapTable
      keyField="id"
      data={items}
      columns={tableColumns}
      bootstrap4
      bordered={false}
      hover
    />
  );
};
